<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            Modelos de documentos

            <button style="margin-left: 15px" data-toggle="modal" data-target="#listar-variaveis-modal" class="btn btn-info">
              Visualizar variáveis
            </button>
          </h1>
        </div>
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/modelos/documentos">Modelos de documentos</a></li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <!-- NOVO DOCUMENTO -->
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Novo documento</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Arquivo</label>
              <div class="custom-file">
                <input class="form-control" type="file" @change="onChange" multiple="multiple" />
              </div>

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.arquivo.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Nome</label>
              <input class="form-control" v-model="formData.nome" />

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Tipo</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo" @change="changeTipo()">
                <option v-for="tipo in tipos" :key="tipo.tipo" :value="tipo.tipo">{{ tipo.tipo }}</option>
              </select>

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.tipo.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Ref</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.ref">
                <option v-for="ref in refs" :key="ref" :value="ref">{{ ref }}</option>
              </select>

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.ref.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Leiloeiro</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.leiloeiro">
                <option v-for="leiloeiro in leiloeiros" :key="leiloeiro" :value="leiloeiro">
                  {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                </option>
              </select>

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.leiloeiro.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Tipo leilão</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_leilao">
                <option value=""></option>
                <option value="extra">Extrajudicial</option>
                <option value="judicial">Judicial</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Tipo cadastro</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_cadastro">
                <option value=""></option>
                <option value="pf">PF</option>
                <option value="pj">PJ</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Tipo lote</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_lote">
                <option value=""></option>
                <option value="imovel">Imóvel</option>
                <option value="movel">Móvel</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Pagamento</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.pagamento">
                <option value=""></option>
                <option value="a_vista">À vista</option>
                <option value="parcelado">Parcelado</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Estado civil</label>

              <select class="custom-select rounded-0" id="tipo" v-model="formData.estado_civil">
                <option value=""></option>
                <option value="casado">Casado</option>
                <option value="solteiro">Solteiro</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <div class="form-group">
              <label>Comitente</label>

              <select class="custom-select rounded-0" id="comitente" v-model="formData.comitente_id">
                <option value=""></option>
                <option v-for="comitente in comitentes" :key="comitente" :value="comitente.id">
                  {{ comitente.nome }} - {{ comitente.cidade }}/{{ comitente.estado }}
                </option>
              </select>

              <span v-if="!formData.editar_modelo" style="color: red" v-for="error in v$.leiloeiro.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12">
            <button @click="store()" class="btn btn-info">Enviar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE PROPOSTAS -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Modelos</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Ref</th>
              <th>Detalhes</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(modelo, index) in modelos_docs" :key="modelo">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">{{ modelo.id }}</td>
              <td data-label="Nome">
                <div class="input-group input-group-sm" v-if="!modelo.edit">
                  <input
                    style="cursor: pointer; width: 70%; font-size: 15px; max-height: 26px"
                    type="text"
                    class="form-control"
                    v-model="modelo.nome"
                    @click="modelo.edit = true"
                    :readonly="!modelo.edit"
                  />

                  <span class="input-group-append">
                    <button style="max-height: 26px" @click="modelo.edit = true" type="button" class="btn btn-info btn-flat">
                      <i class="fa fa-pen"></i>
                    </button>
                  </span>
                </div>

                <form v-on:submit.prevent="editarNomeModelo(modelo)">
                  <div class="input-group" v-if="modelo.edit">
                    <div class="input-group input-group-sm">
                      <input
                        style="width: 70%; font-size: 15px; max-height: 26px"
                        type="text"
                        class="form-control"
                        v-model="modelo.nome"
                        @click="modelo.edit = true"
                      />

                      <span class="input-group-append">
                        <button style="max-height: 26px" @click="editarNomeModelo(modelo)" type="button" class="btn btn-success btn-flat">
                          <i class="fa fa-check"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </form>
              </td>
              <td data-label="Tipo">{{ modelo.tipo }}</td>
              <td data-label="Ref">{{ modelo.ref }}</td>
              <td data-label="Detalhes">
                <div>
                  <span style="font-weight: bold">Tipo leilão:</span>
                  {{ modelo.tipo_leilao }}
                  <br />
                </div>
                <div>
                  <span style="font-weight: bold">Tipo cadastro:</span>
                  {{ modelo.tipo_cadastro }}
                  <br />
                </div>
                <div>
                  <span style="font-weight: bold">Tipo lote:</span>
                  {{ modelo.tipo_lote }}
                  <br />
                </div>
                <div>
                  <span style="font-weight: bold">Pagamento:</span>
                  {{ modelo.pagamento }}
                  <br />
                </div>
                <div>
                  <span style="font-weight: bold">Estado civil:</span>
                  {{ modelo.estado_civil }}
                  <br />
                </div>
                <div>
                  <span style="font-weight: bold">Comitente:</span>
                  {{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                  <br />
                </div>
              </td>

              <td data-label="Ações">
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a :href="getImagePath(modelo)" target="_blank" class="dropdown-item">
                    <i class="fa-solid fa-download"></i>
                    &nbsp;&nbsp; Download
                  </a>

                  <div class="dropdown-divider"></div>
                  <a @click="deletar(modelo)" href="#" class="dropdown-item">
                    <i class="fas fa-trash"></i>
                    &nbsp;&nbsp; Deletar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item" data-toggle="modal" data-target="#editar-modal" type="submit" @click="selecionarModelo(modelo)">
                    <i class="fas fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>
                </div>

                <!--
                <a :href="getImagePath(modelo)" target="_blank" class="btn btn-primary" type="submit" style="margin-right: 5px">
                  <i class="fas fa-search"></i>
                </a>
                <button class="btn btn-danger" type="submit" @click="deletar(modelo)" style="margin-right: 5px">
                  <i class="fas fa-trash"></i>
                </button>
                <button data-toggle="modal" data-target="#editar-modal" class="btn btn-info" type="submit" @click="selecionarModelo(modelo)">
                  <i class="fas fa-pen"></i>
                </button>
                -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + modelos_docs.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL EDITAR -->
    <div class="modal fade" id="editar-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin-top: 30px">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar modelo</h4>
              <br />
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Arquivo</label>
                    <div class="custom-file">
                      <input id="file_editar" class="form-control" type="file" @change="onChangeEditar" multiple="multiple" />
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Nome</label>
                    <input class="form-control" v-model="formData.nome_editar" />

                    <span v-if="formData.editar_modelo" style="color: red" v-for="error in v$.nome_editar.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo</label>

                    <select
                      v-if="formData.editar_modelo"
                      class="custom-select rounded-0"
                      id="tipo"
                      v-model="formData.tipo_editar"
                      @change="changeTipo()"
                    >
                      <option v-for="tipo in tipos" :key="tipo.tipo" :value="tipo.tipo">{{ tipo.tipo }}</option>
                    </select>

                    <span v-if="formData.editar_modelo" style="color: red" v-for="error in v$.tipo_editar.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Ref</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.ref_editar">
                      <option value=""></option>
                      <option v-for="ref in refs" :key="ref" :value="ref">{{ ref }}</option>
                    </select>

                    <span v-if="formData.editar_modelo" style="color: red" v-for="error in v$.ref_editar.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Leiloeiro</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.leiloeiro_editar">
                      <option v-for="leiloeiro in leiloeiros" :key="leiloeiro" :value="leiloeiro">
                        {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                      </option>
                    </select>

                    <span v-if="formData.editar_modelo" style="color: red" v-for="error in v$.leiloeiro_editar.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo leilão</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_leilao_editar">
                      <option value=""></option>
                      <option value="extra">Extrajudicial</option>
                      <option value="judicial">Judicial</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo cadastro</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_cadastro_editar">
                      <option value=""></option>
                      <option value="pf">PF</option>
                      <option value="pj">PJ</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo lote</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.tipo_lote_editar">
                      <option value=""></option>
                      <option value="imovel">Imóvel</option>
                      <option value="movel">Móvel</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Pagamento</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.pagamento_editar">
                      <option value=""></option>
                      <option value="a_vista">À vista</option>
                      <option value="parcelado">Parcelado</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3">
                  <div class="form-group">
                    <label>Estado civil</label>

                    <select class="custom-select rounded-0" id="tipo" v-model="formData.estado_civil_editar">
                      <option value=""></option>
                      <option value="casado">Casado</option>
                      <option value="solteiro">Solteiro</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                  <div class="form-group">
                    <label>Comitente</label>

                    <select class="custom-select rounded-0" id="comitente" v-model="formData.comitente_id_editar">
                      <option value=""></option>
                      <option v-for="comitente in comitentes" :key="comitente" :value="comitente.id">
                        {{ comitente.nome }} - {{ comitente.cidade }}/{{ comitente.estado }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12">
                  <button @click="validateUpdate()" class="btn btn-info">Salvar</button>
                  <button style="margin-left: 5px" data-toggle="modal" id="fechar_editar" data-target="#editar-modal" class="btn btn-danger">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- MODAL LISTAR VARIÁVEIS-->
  <div
    class="modal fade"
    id="listar-variaveis-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Variáveis</h4>
            <br />
            <div class="card-body table-responsive p-0">
              <table class="table table-hover" style="position: relative">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Tabela</th>
                    <th>Campo</th>
                    <th>Relacionamento</th>
                    <th>Variavel doc</th>
                    <th>Formatacao</th>
                    <th>Copiar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(variavel, index) in variaveis_documentos" :key="variavel">
                    <td>{{ variavel.nome }}</td>
                    <td>{{ variavel.tabela }}</td>
                    <td>{{ variavel.campo }}</td>
                    <td>{{ variavel.relacionamento }}</td>
                    <td>{{ variavel.variavel_doc }}</td>
                    <td>{{ variavel.formatacao }}</td>
                    <td>
                      <button @click="copiarVariavel(variavel)" type="button" class="btn btn-default btn-sm">
                        <i class="fa-solid fa-copy"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <br />
                <span style="font-weight: bold">Tabelas possíveis:</span>
                <br />
                <span>lotes</span>
                <br />
                <span>leilao</span>
                <br />
                <span>lance</span>
                <br />
                <span>form_proposta</span>
                <br />
                <span>processos</span>
                <br />
                <span>segundo_lance (JOIN)</span>
                <br />
                <br />
                <span style="font-weight: bold">JOINs possíveis:</span>
                <br />
                <span>lotes->processos</span>
                <br />
                <span>lotes->user</span>
                <br />
                <span>lance->user_cadastros</span>
                <br />
                <span>processos->cidades</span>
                <br />
                <span>processos->estados</span>
                <br />
                <br />
                <span style="font-weight: bold">Formatações possíveis:</span>
                <br />
                <span>percentual</span>
                <br />
                <span>moeda</span>
                <br />
                <span>telefone</span>
                <br />
                <span>cpf</span>
                <br />
                <span>ordinal masculino</span>
                <br />
                <span>ordinal feminino</span>
                <br />
                <span>data</span>
                <br />
                <span>cnpj</span>
                <br />
                <span>cep</span>
                <br />
                <span>regime casamento</span>
                <br />
                <span>qualquer outra coisa, não faz nada, ex. &lt;branco&gt;, texto</span>
                <br />
                <br />
                <span style="font-weight: bold">Variáveis de tela possíveis:</span>
                <br />
                <span>total_com_taxas</span>
                <br />
                <span>texto_adicional_01</span>
                <br />
                <span>texto_adicional_02</span>
                <br />
                <span>texto_adicional_03</span>
                <br />
                <span>texto_adicional_04</span>
                <br />
                <span>total_com_taxas</span>
                <br />
                <span>data_pagamento_comissao</span>
                <br />
                <span>data_pagamento_guia</span>
                <br />
                <br />
              </div>
            </div>

            <button style="margin-left: 5px" data-toggle="modal" id="cancelar" data-target="#listar-variaveis-modal" class="btn btn-danger">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import { TimeScale } from "chart.js";

export default {
  props: ["leiloeiros"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      proposta_selecionada: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      propostas: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
      somente_pendentes: true,
      apelido: "",
      leilao_id: "",
      arquivoDocumento: "",
      tipos: [""],
      refs: "",
      modelos_docs: "",
      modelo_selecionado: "",
      variaveis_documentos: "",
      comitentes: [],
    };
  },

  setup() {
    const formData = reactive({
      nome: "",
      tipo: "",
      ref: "",
      arquivo: "",
      leiloeiro: "",
      editar_modelo: false,
      comitente_id: "",
      comitente_id_editar: "",
      tipo_leilao: "",
      tipo_leilao_editar: "",
      tipo_cadastro: "",
      tipo_cadastro_editar: "",
      estado_civil: "",
      estado_civil_editar: "",
      tipo_lote: "",
      tipo_lote_editar: "",
      pagamento: "",
      pagamento_editar: "",
    });

    const rules = computed(() => {
      let local_rules = {};

      if (formData.editar_modelo) {
        local_rules.nome_editar = { required };
        local_rules.tipo_editar = { required };
        local_rules.ref_editar = { required };
        local_rules.leiloeiro_editar = { required };
      } else {
        local_rules.nome = { required };
        local_rules.tipo = { required };
        local_rules.ref = { required };
        local_rules.arquivo = { required };
        local_rules.leiloeiro = { required };
      }

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.tipos.push({
      tipo: "Auto extrajudicial",
      refs: ["PF à vista", "PF parcelado", "PF à vista casado", "PF parcelado casado", "PJ à vista", "PJ parcelado"],
    });

    this.tipos.push({
      tipo: "Auto judicial",
      refs: ["PF à vista", "PF parcelado", "PF à vista casado", "PF parcelado casado", "PJ à vista", "PJ parcelado"],
    });

    this.tipos.push({
      tipo: "Negativo",
      refs: ["Modelo extrajudicial", "Modelo judicial"],
    });

    this.tipos.push({
      tipo: "Nota de venda",
      refs: ["Modelo exclusivo PF", "Modelo exclusivo PJ"],
    });

    this.formData.leiloeiro = this.leiloeiros[0];

    this.buscarModelos();
    this.buscarVariaveisDocumentos();

    this.buscarComitentes();
  },

  methods: {
    async store() {
      this.formData.editar_modelo = false;

      this.$nextTick(async function () {
        const result = await this.v$.$validate();

        if (result) {
          this.isLoading = true;

          this.sendFileS3(this.formData.arquivo, "store");

          /*
          let fd = new FormData();
          fd.append("file", this.formData.arquivo);
          fd.append("tipo", this.formData.tipo);
          fd.append("nome", this.formData.nome);
          fd.append("leiloeiro_id", this.formData.leiloeiro.id);
          fd.append("ref", this.formData.ref);
          fd.append("comitente_id", this.formData.comitente_id);

          console.log("Cadastrando");
          console.log(fd);

          axios
            .post(`/admin/modelos/documentos/store`, fd)
            .then((response) => {
              this.isLoading = false;

              this.showSuccessMessageWithButtonAndReload("Sucesso", "Modelo cadastrado");
            })
            .catch((error) => {
              this.showErrorMessageWithButton("Ops..", error);
              console.log(error);
            });

            */
        }
      });
    },

    async validateUpdate() {
      this.isLoading = true;

      console.log("Editar?");
      console.log(this.formData.editar_modelo);

      const result = await this.v$.$validate();

      if (result) {
        if (this.formData.arquivo_editar) {
          this.sendFileS3(this.formData.arquivo_editar, "update");
        } else {
          this.update();
        }
      } else {
        console.log(this.v$);
      }
    },

    update(file) {
      let data = {
        id: this.modelo_selecionado.id,
        tipo: this.formData.tipo_editar,
        nome: this.formData.nome_editar,
        leiloeiro_id: this.formData.leiloeiro.id,
        tipo_leilao: this.formData.tipo_leilao_editar,
        tipo_cadastro: this.formData.tipo_cadastro_editar,
        estado_civil: this.formData.estado_civil_editar,
        tipo_lote: this.formData.tipo_lote_editar,
        pagamento: this.formData.pagamento_editar,
        ref: this.formData.ref_editar,
        comitente_id: this.formData.comitente_id_editar,
      };

      if (file) {
        let fileName = file.split("/");

        data.file = fileName[fileName.length - 1];
        data.path = "rochaleiloes2/modelos_docs/";
      }

      console.log("ATUALIZANDO");

      axios
        .post(`/admin/modelos/documentos/update`, data)
        .then((response) => {
          this.showSuccessMessage("Documento atualizado");
          this.buscarModelos();
          this.isLoading = false;

          let btn = document.getElementById("fechar_editar");
          btn.click();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    sendFileS3(file, action) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("id", "1");
        formData.append("path", "rochaleiloes2/modelos_docs/");
        formData.append("file", file);

        console.log("Arquivo");
        console.log(file);

        axios
          .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
          .then((response) => {
            console.log(response.data);
            console.log("ENVIANDO PARA O BANCO\n");

            if (action == "update") {
              //DELETANDO ARQUIVO ANTERIOR
              let data = {
                path: this.modelo_selecionado.arquivo,
              };

              console.log("DELETANDO S3");
              console.log(data);

              axios
                .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
                .then((response) => {})
                .catch((error) => {
                  console.log(error);
                  this.isLoading = false;
                  this.showErrorMessageWithButton("Ops..", error);
                });

              this.update(response.data.key);
            } else {
              this.storeDB(response.data.key, action);
            }
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error.response.data.error);
            reject();
          });
      });
    },

    storeDB(file, action) {
      let fileName = file.split("/");

      let data = {
        file: fileName[fileName.length - 1],
        path: "rochaleiloes2/modelos_docs/",
        tipo: this.formData.tipo,
        nome: this.formData.nome,
        leiloeiro_id: this.formData.leiloeiro.id,
        ref: this.formData.ref,
        comitente_id: this.formData.comitente_id,
        tipo_leilao: this.formData.tipo_leilao,
        tipo_cadastro: this.formData.tipo_cadastro,
        estado_civil: this.formData.estado_civil,
        tipo_lote: this.formData.tipo_lote,
        pagamento: this.formData.pagamento,
      };

      console.log("Enviando agora");
      console.log(data);

      let url = "";

      if (action == "store") {
        url = "/admin/modelos/documentos/store_url";
      } else {
        url = "/admin/modelos/documentos/update";

        data.id = this.modelo_selecionado.id;
      }

      axios
        .post(url, data)
        .then((response) => {
          this.isLoading = false;
          if (action == "store") {
            this.showSuccessMessage("Documento enviado!");
          } else {
            this.showSuccessMessage("Documento atualizado!");
          }

          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
        });
    },

    buscarComitentes() {
      let data = {
        inicio: 0,
        tamanho: 100000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    async copiarVariavel(variavel) {
      try {
        await navigator.clipboard.writeText(variavel.variavel_doc);
        this.showSuccessMessage("Dados copiados!");
      } catch ($e) {
        alert("Cannot copy");
        console.log(e);
      }
    },

    /*
    copiarVariavel(variavel) {
      let that = this;

      this.$copyText(variavel.nome).then(
        function (e) {
          console.log(e);
          that.showSuccessMessage("Dados copiados!");
        },
        function (e) {
          alert("Can not copy");
          console.log(e);
        }
      );
    },
    */

    buscarVariaveisDocumentos() {
      this.variaveis_documentos = [];

      axios
        .post(`/admin/variaveis_documentos/search`)
        .then((response) => {
          this.variaveis_documentos = response.data.variaveis_documentos;
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          this.isLoading = false;
        });
    },

    selecionarModelo(modelo) {
      console.log(modelo);

      this.formData.editar_modelo = true;
      this.modelo_selecionado = modelo;

      this.formData.nome_editar = modelo.nome;
      this.formData.tipo_editar = modelo.tipo;
      this.formData.ref_editar = modelo.ref;
      this.formData.leiloeiro_editar = this.leiloeiros[0];
      this.formData.comitente_id_editar = modelo.comitente_id;
      this.formData.arquivo_editar = null;
      this.formData.tipo_leilao_editar = modelo.tipo_leilao;
      this.formData.tipo_cadastro_editar = modelo.tipo_cadastro;
      this.formData.estado_civil_editar = modelo.estado_civil;
      this.formData.tipo_lote_editar = modelo.tipo_lote;
      this.formData.pagamento_editar = modelo.pagamento;

      let btn = document.getElementById("file_editar");
      btn.value = "";

      this.findRefs();
    },

    changeTipo() {
      this.formData.ref = null;

      this.findRefs();
    },

    findRefs() {
      let indice = -1;

      if (this.formData.editar_modelo) {
        indice = this.tipos.findIndex((element) => element["tipo"] == this.formData.tipo_editar);
      } else {
        indice = this.tipos.findIndex((element) => element["tipo"] == this.formData.tipo);
      }

      if (indice >= 0) {
        this.refs = this.tipos[indice].refs;
      }
    },

    editarNomeModelo(modelo) {
      console.log("Editado!");

      let data = {
        id: modelo.id,
        nome: modelo.nome,
        ref: modelo.ref,
        tipo: modelo.tipo,
      };

      axios
        .post(`/admin/modelos/documentos/update`, data)
        .then((response) => {
          this.showSuccessMessage("Nome atualizado!");
          modelo.edit = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(modelo) {
      if (modelo.arquivo && modelo.arquivo.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + modelo.arquivo;
      } else if ((modelo.arquivo && modelo.arquivo.includes("rochaleiloes")) || (modelo.arquivo && modelo.arquivo.includes("fotos_"))) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + modelo.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + modelo.arquivo;
      }
    },

    onChange(e) {
      this.formData.arquivo = e.target.files[0];
    },

    onChangeEditar(e) {
      this.formData.arquivo_editar = e.target.files[0];
    },

    limparFiltros() {
      this.somente_pendentes = true;
      this.apelido = "";
      this.leilao_id = "";

      this.buscarModelos();
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarModelos();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarModelos();
      }
    },

    buscarModelos() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        desc: true,
        somente_pendentes: this.somente_pendentes,
        apelido: this.apelido,
        leilao_id: this.leilao_id,
      };

      console.log(data);

      axios
        .post(`/admin/modelos/documentos/search`, data)
        .then((response) => {
          this.modelos_docs = response.data.modelos_docs;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.propostas);

          this.isLoading = false;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },
    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarModelos();
    },

    deletar(modelo_doc) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            //DELETANDO ARQUIVO
            let data = {
              path: modelo_doc.arquivo,
            };

            console.log("DELETANDO S3");
            console.log(data);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
              .then((response) => {})
              .catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error);
              });

            this.isLoading = true;

            data = {
              id: modelo_doc.id,
            };

            axios
              .post(`/admin/modelos/documentos/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Modelo deletado!");
                //this.hideMenu();
                this.buscarModelos();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1700px;
  margin-left: -530px;
}

@media screen and (max-width: 2000px) {
  .modal-content {
    width: 1400px;
    margin-left: -430px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1200px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
